import { useRoute, useRouter } from '@nuxtjs/composition-api'
import useUser from './useUser'
import useDetectVersion from './useDetectVersion'

export default function useAuthModal(context) {
  const router = useRouter()
  const route = useRoute()

  const { user } = useUser(context)
  const { detectVersionToReload } = useDetectVersion(context)

  function loginSuccessAfter(path = route.value.path) {
    window.dataLayer &&
      window.dataLayer.push({
        event: 'loginEvent',
        username: user.value.username
      })
    const { openLoginModal, target } = route.value.query
    if (!!openLoginModal && target) {
      path = target
    }
    if (route.value.path !== path) {
      router.replace(path, detectVersionToReload, detectVersionToReload)
      return
    }
    detectVersionToReload()
  }

  function signUpSuccessAfter(path = route.value.path) {
    router.push(path, detectVersionToReload, detectVersionToReload)
  }

  function signUpStepSuccessAfter(path = route.value.path) {
    window.dataLayer &&
      window.dataLayer.push({
        event: 'registerEvent',
        username: user.value.username
      })

    router.push(path, detectVersionToReload, detectVersionToReload)
  }

  // replace toggleAuthModal
  // play game, toggle favorite, footer bottom menu, main menu slide modal
  function linkToOpenAuthModal(category = 'login') {
    const query = {
      login: {
        openLoginModal: true,
        target: route.value.path
      },
      signUp: {
        openSignUpModal: true
      }
    }
    router.push({
      path: route.value.path,
      query: {
        ...(query[category] || {}),
        time: new Date().getTime()
      }
    })
  }

  return {
    loginSuccessAfter,
    signUpSuccessAfter,
    signUpStepSuccessAfter,

    linkToOpenAuthModal
  }
}
